import { ComponentType } from '../../table_component'
import { Schema } from '../../types'

export const resourceInfoSchema: Schema = {
  title: 'CPU/Memory/Storage/MBPS/IOPS/Network(For PD/TiDB/TiKV/TiFlash)',
  level: 1,
  columns: [
    {
      id: 'no',
      name: 'No.',
      component: ComponentType.NO
    },
    {
      id: 'name',
      name: 'Statistic Name',
      component: ComponentType.Text
    },
    {
      id: 'avg',
      name: 'Value(avg)',
      component: ComponentType.MetricStats
    },
    {
      id: 'max',
      name: 'Value(max)',
      component: ComponentType.MetricStats
    },
    {
      id: 'delta',
      name: 'Value(delta)',
      component: ComponentType.MetricStats
    },
    {
      id: 'location',
      name: 'Metric Location',
      component: ComponentType.Text
    }
  ]
}
